import { Button, ModalBody, ModalFooter, ModalHeader, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SubmitFormBtn } from '../Buttons/SubmitFormBtn';
import { BaseModal } from './BaseModal';

interface IUserProfileConfirmDeleting {
  isOpen: boolean;
  onClose: VoidFunction;
  onConfirm: VoidFunction;
}

export const UserProfileConfirmDeleting = (props: IUserProfileConfirmDeleting) => {
  const { t } = useTranslation();
  return (
    <BaseModal {...props}>
      <>
        <ModalHeader>{t('modal.deleting.profile.caption')}</ModalHeader>

        <ModalBody>
          <Text>{t('modal.deleting.profile.text')}</Text>
        </ModalBody>

        <ModalFooter>
          <VStack spacing={4}>
            <SubmitFormBtn size='lg' minH={14} py={2} onClick={props?.onConfirm}>
              {t('confirm.deleting')}
            </SubmitFormBtn>
            <Button variant='linkUnderlinePrimary' size='sm' onClick={props?.onClose}>
              {t('cancel')}
            </Button>
          </VStack>
        </ModalFooter>
      </>
    </BaseModal>
  );
};
